// extracted by mini-css-extract-plugin
module.exports = {"list":"Dropdown_list__g6GNx"};